import { LangText } from '@/components'

const PRECAUTION_ITEMS = [
  'coupon.precautions.items.showAtCheckout',
  'coupon.precautions.items.passportForTaxFree',
  'coupon.precautions.items.seeCouponNotes',
] as const

/** 优惠券注意事项 `/coupon-precautions` */
export default function CouponPrecautions() {
  return (
    <div className="min-h-[calc(100vh-var(--spacing)*45)] bg-[#FAFAFA]">
      <div className="px-6 py-10 mx-auto max-w-4xl md:px-10">
        <LangText
          lngKey="coupon.list.quickLinks.precautions"
          className="mb-6 block text-[26px] font-bold text-[#1a1a1a] md:text-[32px]"
        />
        <ul className="list-disc space-y-[12px] pl-[28px] text-[18px] leading-[1.75] text-[#333] md:text-[20px]">
          {PRECAUTION_ITEMS.map((key) => (
            <li key={key}>
              <LangText lngKey={key} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
